<template>
  <div class="order-detail-2">
    <div class="order-detail-2-top">
      <ul class="top-list">
        <li
            v-for="item in navList"
            :key="item.val"
            @click="changeNav(item.val)"
            :class="item.val === curTab ? 'on' : ''"
        >
          {{ item.txt }}
        </li>
      </ul>
      <div class="detail-header-btn">
        <Button
            type="primary"
            icon="md-add"
            @click="editOrder"
            v-if="isHavePermission('matchOrder:orderList:edit') && detailData && detailData.ordersStateAll !== 5 && detailData.ordersStateAll !== 6 && detailData.ordersStateAll !== 7"
        >编辑订单
        </Button>
        <Dropdown
            style="margin-left: 10px"
            v-if="
            isHavePermission('matchOrder:orderList:createInvoice') ||
            isHavePermission('matchOrder:orderList:invoiceAudit')
          "
        >
          <Button>
            更多操作
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
                v-if="isHavePermission('matchOrder:orderList:createInvoice')"
                @click.native="showCreateInvoice()"
            >申请发票代开
            </DropdownItem>
            <DropdownItem
                v-if="isHavePermission('matchOrder:orderList:invoiceAudit')"
                @click.native="invoiceAuditCheck"
            >订单审核
            </DropdownItem>
            <DropdownItem
                @click.native="commitBack"
            >订单强制退回
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button icon="md-refresh" @click="freshen" style="margin-left: 10px">刷新</Button>
        <Icon
            @click="showAudiList"
            v-if="ordersStateAll === 4"
            type="md-list-box"
            size="28"
            color="#2d8cf0"
            style="margin-left: 10px; vertical-align: middle"
        />
      </div>
    </div>
    <div v-show="curTab === 1">
      <detail-title
          :title="'基础信息'"
          :info="
          isHavePermission('ordersTwo:createTime')
            ? `创建人：${createUser} | 日期：${createTime}`
            : `创建人：${createUser}`
        "
      ></detail-title>
      <info-create :detailData="detailData" :isDetail="true"></info-create>
      <detail-title :title="'货物信息'"></detail-title>
      <goods-create :detailData="detailData" :isDetail="true"></goods-create>
      <detail-title :title="'物流信息'"></detail-title>
      <logistics-create :detailData="detailData" :isDetail="true" @refresh="freshen"></logistics-create>
      <detail-title :title="'付款信息'"></detail-title>
      <pay-create :detailData="detailData" :isDetail="true"></pay-create>
      <detail-title :title="'结算信息'"></detail-title>
      <pay-info :detailData="detailData" :isDetail="true"></pay-info>
    </div>
    <div v-show="curTab === 2" class="other-box">
      <!-- <income-invoice
        :id="id"
        :pageTab="curTab"
        ref="incomeInvoice"
      ></income-invoice> -->
      <pay-invoice :id="id" :pageTab="curTab" ref="payInvoice"></pay-invoice>
    </div>

    <!-- <vxe-modal
      v-model="receivingVisible"
      v-if="receivingVisible"
      title="新建结算信息"
      width="1300"
      position="center"
      @close="closeReceivingCreate"
      height="660"
      resize
    >
      <create-receiving
        ref="receivingModal"
        @createCommit="createCommit"
        :orderId="id"
        :endTime="endTime"
      ></create-receiving>
    </vxe-modal> -->
    <!-- <vxe-modal
      v-model="isShowCreateCollection"
      title="款项收入流程"
      width="1300"
      height="760"
      position="center"
      resize
    >
      <create-collection
        :cate="'Collection'"
        :isShow="isShowCreateCollection"
        ref="createCollectionModal"
        @close="isShowCreateCollection = false"
        @init="init"
      ></create-collection>
    </vxe-modal> -->
    <!-- <vxe-modal
      v-model="isShowCreatePayment"
      title="费用支出流程"
      width="1300"
      height="760"
      resize
      position="center"
    >
      <create-payment
        :cate="'Payment'"
        :isShow="isShowCreatePayment"
        ref="createPaymentModal"
        @close="isShowCreatePayment = false"
        @init="init"
      ></create-payment>
    </vxe-modal> -->
    <vxe-modal v-model="isShowCreateInvoice" width="1300" height="660" resize position="center" destroy-on-close>
      <div slot="title">开票申请流程</div>
      <create-invoice
          :cate="'Sales'"
          :isShow="isShowCreateInvoice"
          @close="isShowCreateInvoice = false"
          @init="init"
          ref="createInvoice"
      ></create-invoice>
    </vxe-modal>
    <!-- <vxe-modal
      v-model="isShowCreateInvoice2"
      width="1300"
      height="660"
      resize
      position="center"
    >
      <div slot="title">抵扣票申请流程</div>
      <create-invoice
        :cate="'Income'"
        :isShow="isShowCreateInvoice2"
        @close="isShowCreateInvoice2 = false"
        @init="init"
        ref="createInvoice2"
      ></create-invoice>
    </vxe-modal> -->
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="500"
        height="250"
        @close="closeMessage"
        remember
    >
      <Message ref="messageModal" @close="closeMessage" :id="id"></Message>
    </vxe-modal>
    <vxe-modal v-model="isShowAudiList" title="审核菜单" width="800" height="700" @close="isShowAudiList = false"
               position="center">
      <audit-record :isMatching="true" ref="auditRecord"></audit-record>
    </vxe-modal>
  </div>
</template>

<script>
import getAuthOrization from "@/mixin/getAuthOrization";
import DetailTitle from "@/components/common/DetailTitle"; // 标题组件
// import IncomeInvoice from "@/components/order2.0/Invoice/IncomeInvoice";
import PayInvoice from "@/components/matching/PayInvoice";
// import CreateReceiving from "@/components/order2.0/Receiving/CreateReceiving";
import $api from "@/apiProvider";
import {apiPost} from "@/utils/api";
import moment from "moment";
import {hideLoading, isEmpty, showLoading, showErrorData} from "@/utils/util";
// import CreateCollection from "@/components/proceduremodal/CollectionProcedure.vue";
// import CreatePayment from "@/components/proceduremodal/PayProdure.vue";
import CreateInvoice from "@/components/proceduremodal/CreateInvoice.vue";
import Message from "@/components/matching/InvoiceMessage";
import AuditRecord from "@/components/tax/AuditRecord";
import PayCreate from "@/components/matching/PayCreate";
import LogisticsCreate from "@/components/matching/LogisticsCreate";
import GoodsCreate from "@/components/matching/GoodsCreate";
import InfoCreate from "@/components/matching/InfoCreate";
import PayInfo from "@/components/matching/PayInfo";

export default {
  mixins: [getAuthOrization],
  components: {
    DetailTitle,
    // CreateReceiving,
    // IncomeInvoice,
    // CreateCollection,
    // CreatePayment,
    PayInvoice,
    CreateInvoice,
    Message,
    PayCreate,
    LogisticsCreate,
    GoodsCreate,
    InfoCreate,
    PayInfo,
    AuditRecord
  },
  data() {
    return {
      id: this.$route.params.id, // 主键ID
      navList: [
        {
          txt: "订单信息",
          val: 1,
        },
        {
          txt: "发票信息",
          val: 2,
        },
      ],
      curTab: 1,
      timeLineList: null,
      // receivingVisible: false,
      detailData: {},
      busType: 1,
      createUser: "",
      createTime: "",
      // isShowCreateCollection: false,
      // isShowCreatePayment: false,
      isShowCreateInvoice: false,
      // isShowCreateInvoice2: false,
      messageVisible: false,
      state: null,
      endTime: null,
      ordersStateAll: null,
      isShowAudiList: false,
    };
  },
  watch: {
    $route(to, from) {
      this.id = parseInt(this.$route.params.id);
      if (to.name === "编辑订单2.0") {
        this.getOrderDetail(this.id);
      }
    },
  },
  created() {
    this.getDicDate();
  },
  methods: {
    showAudiList() {
      this.isShowAudiList = true;
      this.$refs.auditRecord.init(this.id);
    },
    async invoiceAuditCheck() {
      let res = await $api.matchOrder.request("invoiceAuditCheck", {
        id: this.id,
      });
      if (res.status === 1) {
        this.messageVisible = true;
      } else {
        // this.messageVisible = true;
        this.$Modal.error({
          title: "错误提示",
          content: res.message,
        });
      }
    },
    commitBack() {
      this.$XModal.confirm("订单状态将被强制退回到执行中?").then(type => {
        if (type === "confirm") {
          this.updateStateProc();
        }
      });
    },
    async updateStateProc() {
      let res = await $api.matchOrder.request("updateStateProc", {
        id: this.id,
      });
      if (res.status === 1) {
        this.$Message.success("退回成功");
        this.getOrderDetail(this.id);
      } else {
        this.$Modal.error({
          title: "错误提示",
          content: res.message,
        });
      }
    },
    closeMessage() {
      this.messageVisible = false;
    },
    changeNav(val) {
      this.curTab = val;
    },
    freshen() {
      switch (this.curTab) {
        case 1:
          this.getOrderDetail(this.id);
          break;
        case 2:
          // this.invoiceType = 2;
          this.$refs.payInvoice.init();
          break;
      }
    },
    editOrder() {
      window.location.href = `/matching/orderedit/${this.id}?isByDetail=true`;
    },
    // showCreateCollection() {
    //   this.isShowCreateCollection = true;
    //   this.$refs.createCollectionModal.initByOrderInfo(this.detailData);
    // },
    // ShowCreatePaymentModal() {
    //   this.isShowCreatePayment = true;
    //   this.$refs.createPaymentModal.initByOrderInfo(this.detailData, 2);
    // },
    showCreateInvoice() {
      localStorage.setItem("detailData", JSON.stringify(this.detailData));
      window.open('/procedure/taxInvoice/order/true')
    },
    init() {
      this.freshen();
    },
    goCreateOrder() {
      window.open(`/order2/ordercreate?id=${this.id}`);
    },
    // showReceivingModal() {
    //   this.receivingVisible = true;
    // },
    // createCommit() {
    //   this.receivingVisible = false;
    //   this.$refs.receivingList.getReceivingListData();
    // },
    // closeReceivingCreate() {
    //   this.$refs.receivingModal.clearTableV();
    // },
    // delReceiving(row) {
    //   this.$XModal.confirm("您确定要删除吗？").then(type => {
    //     if (type === "confirm") {
    //       this.deleteCommit(row);
    //     }
    //   });
    // },
    // async deleteCommit(row) {
    //   let del = {
    //     ordersSettleType: row,
    //     ordersId: this.id
    //   };
    //   let res = await $api.twoSettlement.request("delete", del);
    //   if (res.status == 1) {
    //     this.$Message.success("删除成功");
    //     this.records = [];
    //     this.$refs.receivingList.init();
    //   } else {
    //     this.$XModal.alert({
    //       message: res.message ? res.message : "接口异常",
    //       status: "error"
    //     });
    //   }
    // },
    // async commitBatchUpdateStatus(state, isEnforce = false) {
    //   this.state = state;
    //   if (!isEnforce) {
    //     let confirm = await this.$XModal.confirm("您确定要批量修改状态吗？");
    //     if (confirm !== "confirm") {
    //       return;
    //     }
    //   }

    //   let idList = [];
    //   let error = "";
    //   idList.push(this.detailData.id);
    //   if (state === 1) {
    //     if (this.detailData.isComplete == 1) {
    //       error = "该订单已是完成状态;";
    //     }
    //   } else if (state === 4) {
    //     if (this.detailData.isComplete == 4) {
    //       error = "该订单已是结束状态;";
    //     }
    //   } else if (state === 5) {
    //     if (this.detailData.isComplete == 5) {
    //       error = "该订单已是待完善状态;";
    //     }
    //   }
    //   if (error !== "") {
    //     this.$Modal.error({
    //       title: "错误提示",
    //       content: error
    //     });
    //     return;
    //   }
    //   showLoading();
    //   let res;
    //   if (state === 4 || state === 5) {
    //     res = await $api.twoOrders.post("updateState", { idList, state });
    //   } else if (state === 1) {
    //     let params = {
    //       idList
    //     };
    //     if (isEnforce) {
    //       params.isEnforce = 1;
    //     }
    //     res = await $api.twoOrders.post("updateStateToComplete", params);
    //   }
    //   hideLoading();
    //   if (res.status == 1) {
    //     this.$Message.success("操作完成");
    //     if (isEnforce) {
    //       this.closeMessage();
    //     }
    //     this.getOrderDetail(this.id);
    //   } else if (res.status == 0) {
    //     showErrorData(res.data);
    //   } else if (res.status == 999) {
    //     let content = "";
    //     res.data.forEach((item, index) => {
    //       let msg = "错误: " + item.failMsg;
    //       content = content + msg + "\n";
    //     });
    //     this.$refs.messageModal.setMessage(content);
    //     this.messageVisible = true;
    //   }
    // },
    // setUpdateStatus() {
    //   this.commitBatchUpdateStatus(this.state, true);
    // },
    getDicDate() {
      this.contractListType = [];
      $api.other.getOrderBusTypeModelTwo
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.encoded),
              };
              this.contractListType.push(obj);
            });
            this.getOrderDetail(this.id);
          });
    },
    async getOrderDetail(id) {
      this.detailData = null;
      showLoading();
      let res = await $api.matchOrder.post("detail", {id});
      hideLoading();
      if (res.status === 1) {
        document.title = res.data.saleMan ? (res.data.carShipNum ? res.data.carShipNum + '订单详情' + '(' + res.data.saleMan + ')' : '订单详情' + '(' + res.data.saleMan + ')') : res.data.carShipNum + '订单详情';
        this.detailData = res.data;
        this.createUser = res.data.createUser;
        this.createTime = moment(res.data.createTime).format("YYYY-MM-DD");
        this.ordersStateAll = res.data.ordersStateAll;
      }
    },
  },
};
</script>

<style lang="less">
.order-detail-2 {
  padding: 20px;

  .order-detail-2-top {
    width: 100%;
    height: 36px;
    position: relative;

    ul.top-list {
      float: left;
      height: 100%;
      border-bottom: 1px solid #dfdfdf;

      li {
        float: left;
        height: 16px;
        line-height: 16px;
        margin: 0 20px;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        cursor: pointer;
      }

      li.on {
        color: #438df3;
        font-weight: bold;
      }

      li.on::after {
        content: "";
        display: block;
        width: 60px;
        height: 2px;
        background-color: #438df3;
        position: absolute;
        left: 0;
        bottom: -20px;
      }
    }
  }

  .other-box {
    padding-top: 20px;
  }
}
</style>
